import * as React from 'react';

// internal logic
// eslint-disable-next-line import/prefer-default-export
export const CardRowContext = /*#__PURE__*/React.createContext(false);